var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlayCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1.4a5.6 5.6 0 1 1 0 11.2A5.6 5.6 0 0 1 7 1.4m-.832 3.588c-.432-.253-.788-.049-.788.46v3.241c0 .513.353.715.788.46l2.776-1.62c.433-.252.436-.666 0-.92z"
})));
export default SvgIconPlayCircle;